"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Alert;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Alert({
  type = 'info',
  children
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'alert alert-' + type
  }, children);
}